// removed by extract-text-webpack-plugin
module.exports = {"modal":"SZOeq","modal-background":"AVzuL","title":"_3iRYG","description":"_1HSEf","button-container":"_1MEvR","close":"_9GvDt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReminderModal/ReminderModal.scss
// module id = ./src/components/ReminderModal/ReminderModal.scss
// module chunks = 4